import React, { useState, useEffect } from 'react';
import { Modal,  Button } from "react-bootstrap";
import { BASE_URL } from "../../../constants";
import axios from 'axios';

//const DiscountModal = ({ show, handleClose, handleSave }) => {
const EditBudgetAllocModal = ({ show, handleClose, onRowSelect }) => {

  const [searchResults, setSearchResults] = useState([]);

//  const [showsearchModal, setShowSearchModal] = useState(false);

  useEffect(() => {
    
    const fetchLists = async () => {
      try {
        const [searchRes] = await Promise.all([
            axios.get(`${BASE_URL}/api/get_budget_alloc`),
        ]);

        setSearchResults(searchRes.data);

      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchLists();

  }, []);


  return (
    <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Budget Allocation - Edit</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        {/* <Table bordered hover responsive> */}
        <div style={{ minHeight: '430px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table-modal scty-custom-table hover-table-rcpt">
            <thead>
              <tr>
                <th style={{ width: '8%', textAlign: 'center' }}> Year</th>
                <th style={{ width: '60%', textAlign: 'left' }}>Budget Head</th>
              </tr>
            </thead>
            <tbody>
              {searchResults.length === 0 ? (
                <tr><td colSpan="2" className="text-center">No Data</td></tr>
              ) : (
                searchResults.map((row, index) => (
                  <tr key={index} onClick={() => onRowSelect(row)} style={{ cursor: 'pointer' }}>
                    <td style={{ textAlign: 'center' }}>{row.fin_years}</td>
                    <td style={{ textAlign: 'left' }}>{row.bgt_name}</td>
                  </tr>
                ))
              )}
            </tbody>
            {/* </Table> */}
          </table>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditBudgetAllocModal;
